import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import i18n from '../../../i18n/i18n.js';

import './Checkbox.css';

class Checkbox extends React.Component {

  parent = null;
  
  constructor(props) {
    super(props);

    this.parent = typeof props.parent !== 'undefined' ? props.parent : null;
    this.ws_data = typeof props.ws_data !== 'undefined' ? props.ws_data : null;

    this.state = {};
  }

  render() {
    const { formData, formErrors } = this.parent.state;
    const parent = this.parent;
    const ws_data = this.ws_data;

    const is_multi = Object.keys(ws_data.values).length > 1;

    return <div className="row">
      {ws_data.label ? <label className="form_label">{ws_data.label}{ws_data.required ? ' *' : ''}</label> : ''}
      <div className={`field field_checkbox ${ws_data.fieldname} ${formErrors[ws_data.fieldname] !== '' ? "error" : ""}`}>
          {Object.keys(ws_data.values).map((key) => {
            
            let is_checked = false;

            if(is_multi)
            {
               const data = formData[ws_data.fieldname];
               if(data && typeof data === 'object'){
                  is_checked = data[key] == 1;
               }
            }
            else
            {
               is_checked = formData[ws_data.fieldname] == 1;
            }

            return <div key={key} className="checkbox">
              <input id={`${ws_data.fieldname}_${key}`} checked={is_checked} type="checkbox" value="1" onChange={(e) => {
                
                let new_val = null;

                if (is_multi)
                {
                   const data = formData[ws_data.fieldname];
                   new_val = (data && typeof data === 'object') ? {...data} : {};
                   new_val[key] = is_checked ? 0 : 1;
                }
                else
                {
                   new_val = is_checked ? 0 : 1;
                }

                parent.handle_change(e, ws_data.fieldname, {force_value: new_val});
                
                }} /> 
              <label htmlFor={`${ws_data.fieldname}_${key}`} dangerouslySetInnerHTML={{__html: ws_data.values[key]}}></label>
            </div>;
          })}
          {parent.render_form_error(ws_data.fieldname)}
      </div>
    </div>;
  }
};

export default Checkbox;
